import styled from 'styled-components';
import { BLACK, VIOLET_600, POWDER_BLUE } from '../../styles/colors';
import { GIVONIC, INTER } from '../../styles/fonts';

export const DialogOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
`;

export const DialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${POWDER_BLUE};
  padding: 12px;
  border-radius: 12px;
  gap: 12px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 12px 0px;
  gap: 6px;
`;

export const DialogTitle = styled.span`
  font-family: ${GIVONIC.bold};
  font-size: 20px;
  color: ${BLACK};
`;

export const DialogDescription = styled.span`
  font-family: ${INTER.regular};
  font-size: 14px;
  color: ${VIOLET_600};
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;
